import { BumpoutTimesheetList } from './views/bumpout-timesheet-list';

export default {
  list: BumpoutTimesheetList,
  name: 'bump-resource-sheet',
  label: 'Bumpout Timesheets',
  to: '/bump-resource-sheet',
};
